"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const styleOverrides = {
  root: {
    color: _constants.colors.defaultColors.dark,
    '&:hover': {
      backgroundColor: _constants.colors.oriGrey[100]
    },
    [`&.${_material.radioClasses.checked}`]: {
      color: _constants.colors.defaultColors.dark
    },
    [`&.${_material.radioClasses.checked}.${_material.radioClasses.disabled}`]: {
      color: _constants.colors.oriGrey[400]
    }
  }
};
const defaultProps = {
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.RadioButtonEmpty, {}),
  checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.RadioButtonChecked, {}),
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiRadio.js.map